import { render, staticRenderFns } from "./SwiperModel.vue?vue&type=template&id=a9743b54&scoped=true&"
import script from "./SwiperModel.vue?vue&type=script&lang=js&"
export * from "./SwiperModel.vue?vue&type=script&lang=js&"
import style0 from "./SwiperModel.vue?vue&type=style&index=0&id=a9743b54&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.0@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9743b54",
  null
  
)

export default component.exports